module.exports = __webpack_public_path__ + "img/features-thumb-1.3cb53eab.png";